// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"25":"StartLesson","94":"Login","309":"homeView","639":"SetTraining"}[chunkId] + "." + {"25":"d907d58b","94":"391b5caf","309":"bdd4a291","639":"c583176d"}[chunkId] + ".css";
};